import {UserManager, WebStorageStateStore} from 'oidc-client-ts'
import type {KeycloakConfig} from './types'
import {isKeycloakSession} from '~/composables/useAuthProvider'

/**
 * Create the Keycloak UserManager if it's the active session, else null.
 */
export function createKeycloakUserManager(nuxtApp: any): UserManager | null {
  if (!isKeycloakSession('createKeycloakUserManager')) {
    return null
  }

  const config = nuxtApp.$config.public.keycloak as KeycloakConfig
  if (!config?.authority) {
    return null
  }

  const host = nuxtApp.$config.public.BASE_URL

  return new UserManager({
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: host + '/auth',
    response_type: 'code',
    scope: config.scope,
    automaticSilentRenew: false,
    userStore: new WebStorageStateStore({
      prefix: 'ENuxtKeycloakUser.',
      store: globalThis.localStorage
    }),
    stateStore: new WebStorageStateStore({
      prefix: 'ENuxtKeycloakState.',
      store: globalThis.localStorage
    })
  })
}
